// ====================================================
// Sets up boxes on the review page
(function BlogReviews() {

  const $container = $('.card-article-container');
  const $columns = [];
  let biggestColumnHeight = 0;

  // Cache all columns
  $('.card-list__column').each(function() {
    $columns.push($(this));
  });

  // Assume first column to be the biggest
  biggestColumnHeight = $columns[0].outerHeight() + 1;

  $('.card').each(function() {
    let $card = $(this);
    let nextColumn = getNextColumn($card);
    $columns[nextColumn].append($card);
  })

  // Fetches the next column to append a card to
  function getNextColumn($card) {
    let candidateHeight = biggestColumnHeight;
    let candidateIndex = null;

    for (let i = 0; i < $columns.length; i++) {
      let currentHeight = $columns[i].outerHeight();

      // If already biggest column, skip
      if (currentHeight === biggestColumnHeight) {
        continue;
      }

      // If column is smaller than the biggest, store as candidate
      else if (currentHeight < candidateHeight) {
        candidateHeight = currentHeight;
        candidateIndex = i;
      }

      // If found a bigger column, store as new biggest
      else if (currentHeight > biggestColumnHeight) {
        biggestColumnHeight = currentHeight;
      }
    }

    // If no candidate found, add CSS to create artificial height and return last column
    if (candidateIndex === null) {
      $card.css('border', '1px solid white');
      return $columns.length - 1;
    }

    // Return candidate column index
    return candidateIndex;
  }

  
})();
